import LocalFireDepartmentOutlinedIcon from "@mui/icons-material/LocalFireDepartmentOutlined";
import { Box, Typography } from "@mui/material";
import { fontWeight } from "config/Theme/options";
import { useMUIThemeModeContext } from "context/MUIThemeModeContext";
import useResponsiveFont from "hooks/useResponsiveFont";
import { useTranslation } from "react-i18next";

interface StreakBlockProps {
  streakCount: number;
}

const StreakBlock: React.FC<StreakBlockProps> = ({ streakCount }) => {
  const { getResponsiveRem } = useResponsiveFont();
  const { t } = useTranslation();
  const { colors } = useMUIThemeModeContext();

  return (
    <Box display="flex" alignItems="center" width="fit-content">
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        bgcolor={colors.white}
        borderRadius={1}
        p={0.6}
        mr={1}>
        <LocalFireDepartmentOutlinedIcon color="primary" />
      </Box>
      {streakCount
        ? <Box>
            <Typography fontSize={getResponsiveRem(0.875)} fontWeight={fontWeight.extraBold} fontFamily={"Nunito"}>
              {t("bitcoinerChallenge.weeklyQuiz.weeks", { count: streakCount })}
            </Typography>
            <Typography
              fontSize={getResponsiveRem(0.8125)}
              fontWeight={fontWeight.semiBold}
              fontFamily={"Nunito"}
              color={colors.gray500}>
              {t("bitcoinerChallenge.weeklyQuiz.streak")}
            </Typography>
          </Box>
        : <Typography fontSize={getResponsiveRem(0.875)} fontWeight={fontWeight.extraBold} fontFamily={"Nunito"}>
            {t("bitcoinerChallenge.weeklyQuiz.newStreak")}
          </Typography>}
    </Box>
  );
};

export default StreakBlock;
